<template>
  <div>
    <div style="width: 100%; ">

      <h1>Πίνακας Μεταβολών</h1>
      <span>Σύνολο: {{totalItems}}</span>
    </div>
    <div style="width: 80%; ">

            <div class="d-flex justify-content-center">
              <b-container>
              <b-row >
                  <b-col cols="12" class="d-flex align-items-center justify-content-end mb-2" style="gap: 0.5rem;">
                      <label class="mb-0 text-nowrap" style="font-size:0.875rem;">Από:</label>
                      <b-form-input
                          v-model="dateFrom"
                          type="date"
                          size="sm"
                          style="width: 16ch;"
                      />
                      <label class="mb-0 text-nowrap" style="font-size:0.875rem;">Έως:</label>
                      <b-form-input
                          v-model="dateTo"
                          type="date"
                          size="sm"
                          style="width: 16ch;"
                      />
                      <b-button size="sm" variant="outline-secondary" @click="clearDateFilter">✕</b-button>
                  </b-col>
                  <b-button variant="success" class="float-left" size="sm"  v-on:click="exportChanges"><b-icon icon="cloud-download" aria-hidden="true" ></b-icon> Κατέβασμα Excel</b-button>
                  <b-table  class="mx-auto" show-empty striped :items="changedUsers" :fields="fields" :current-page="currentPage" :per-page="0">
                      <template #cell(submittedDiav)="data">
                          <span v-if="data.item.submittedDiav">NAI</span>
                          <span v-else>OXI</span>
                      </template>
                      <template #cell(actions)="data">
                          <b-button v-if="!data.item.submittedDiav" @click="changeStatus(data.item)" variant="success">ΑΠΟΘΗΚΕΥΣΗ</b-button>
                      </template>
                  </b-table>
                  <b-pagination size="md" :total-rows="totalItems" v-model="currentPage" @change="pageChange" :per-page="perPage"></b-pagination>
              </b-row>
              </b-container>
            </div>


    </div>
  </div>
</template>

<script>
    import {HTTP} from "../main.js";

    export default {
        data: function() {

            if(this.$store.getters.userRole == "ROLE_SXHMATISMOS") {


            return {
                changedUsers: [

                ],
                fields: [
                    {
                        key: 'efsa',
                        label: 'ΣΑ'
                    },
                    {
                      key: 'firstName',
                      label: 'Ονομα'
                    },
                    {
                      key: 'lastName',
                      label: 'Επώνυμο'
                    },
                                        {
                      key: 'monaLek',
                      label: 'Μονάδα ΜΕ'
                    },
                    {
                        key: 'userName',
                        label: 'Ποιός έκανε αλλαγή;'
                    },
                    {
                        key: 'field',
                        label: 'Τι άλλαξε;'
                    },
                    {
                        key: 'oldValue',
                        label: 'Προηγούμενη τιμή'
                    },
                    {
                        key: 'newValue',
                        label: 'Νέα Τιμή'
                    },
                    {
                        key: 'submittedDiav',
                        label: 'Έχει περαστεί η αλλαγή;'
                    },
                    {
                        key: 'actions',
                        label: 'Ενέργεια'
                    },
                    {
                        key: 'dateTime',
                      label: 'Ημερομηνία καταχώρησης'
                    }
                ],
                currentPage: 1,
                perPage: 10,
                totalItems: 0,
                dateFrom: '',
                dateTo: ''
            };
            } else {

            return {
                changedUsers: [

                ],
                fields: [
                    {
                        key: 'efsa',
                        label: 'ΣΑ'
                    },
                    {
                      key: 'firstName',
                      label: 'Ονομα'
                    },
                    {
                      key: 'lastName',
                      label: 'Επώνυμο'
                    },
                    {
                        key: 'userName',
                        label: 'Ποιός έκανε αλλαγή;'
                    },
                    {
                        key: 'field',
                        label: 'Τι άλλαξε;'
                    },
                    {
                        key: 'oldValue',
                        label: 'Προηγούμενη τιμή'
                    },
                    {
                        key: 'newValue',
                        label: 'Νέα Τιμή'
                    },
                    {
                        key: 'submittedDiav',
                        label: 'Έχει περαστεί η αλλαγή;'
                    },
                    {
                        key: 'actions',
                        label: 'Ενέργεια'
                    },
                    {
                        key: 'dateTime',
                      label: 'Ημερομηνία καταχώρησης'
                    }
                ],
                currentPage: 1,
                perPage: 10,
                totalItems: 0,
                dateFrom: '',
                dateTo: ''
            };

            }



        },

        mounted() {
            this.fetchData()
        },

        watch: {
            dateFrom() {
                this.currentPage = 1;
                this.fetchData();
            },
            dateTo() {
                this.currentPage = 1;
                this.fetchData();
            }
        },

        methods: {
            pageChange(page) {
                this.currentPage = page;
                this.fetchData()
            },
            clearDateFilter() {
                this.dateFrom = '';
                this.dateTo = '';
            },
            changeStatus(item){
                let url = "/admin/save-change?id="+ item.id;

                this.$store.dispatch('loading');

                HTTP.post(url).then(response => {
                    this.changedUsers.forEach(it => {
                        if (it.id === item.id) {
                            it.submittedDiav = true
                        }
                    })
                }).finally(() => {
                    this.$store.dispatch('stop_loading');
                });
            },
            async fetchData() {
                let size = this.perPage == null ? 10 : this.perPage;
                let page = (this.currentPage == null ? 1 : this.currentPage) - 1;

                var meeResponsible = this.$store.getters.meeResponsible;
                let dateParams = '';

                if (this.dateFrom) {
                    dateParams += "&dateFrom=" + encodeURIComponent(this.dateFrom);
                }
                if (this.dateTo) {
                    dateParams += "&dateTo=" + encodeURIComponent(this.dateTo);
                }

                let url = '/home'

                if (this.$store.getters.userRole === "ROLE_MANAGER") {
                    url = "/manager/fetch-changes-by-me?page="+ page +"&size="+ size +"&moep="+meeResponsible + dateParams;
                } else if (this.$store.getters.userRole === "ROLE_ADMIN" || this.$store.getters.userRole === "ROLE_SUPERADMIN") {
                    url = "/admin/fetch-changes?page="+ page +"&size="+ size + dateParams;
                } else if(this.$store.getters.userRole === "ROLE_SXHMATISMOS") {
                    url = "/manager/fetch-changes-by-sxhmatismos?page="+ page +"&size="+ size +"&moep="+meeResponsible + dateParams;
                }

                //  let url = "/admin/fetch-changes?page="+ page +"&size="+ size +"";

                this.$store.dispatch('loading');

                HTTP.get(url).then(response => {
                    this.changedUsers = response.data.responseData.content || [];
                    this.totalItems = response.data.responseData.totalElements || 0;
                }).catch((error) => {
                    console.error(error);
                    this.$store.dispatch('stop_loading');
                }).finally(() => {
                    this.$store.dispatch('stop_loading');
                });
            },
            exportChanges() {
              let size = 1000000;
              let page = 0;

              var meeResponsible = this.$store.getters.meeResponsible;
              let url = '/home';
                            let dateParams = '';

                            if (this.dateFrom) {
                                dateParams += "&dateFrom=" + encodeURIComponent(this.dateFrom);
                            }
                            if (this.dateTo) {
                                dateParams += "&dateTo=" + encodeURIComponent(this.dateTo);
                            }

              if (this.$store.getters.userRole === "ROLE_MANAGER") {
                                url = "/manager/download-changes-by-mee?page="+ page +"&size="+ size +"&moep="+meeResponsible + dateParams;
              } else if (this.$store.getters.userRole === "ROLE_ADMIN" || this.$store.getters.userRole === "ROLE_SUPERADMIN") {
                                url = "/admin/download-changes?page="+ page +"&size="+ size + dateParams;
              } else if (this.$store.getters.userRole === "ROLE_SXHMATISMOS") {
                                url = "/manager/download-changes-by-sxhmatismos?page="+ page +"&size="+ size +"&moep="+meeResponsible + dateParams;
              }
              this.$store.dispatch("loading")
              HTTP.get(url, {
                responseType: 'blob'
              }).then(res => {
                let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'efedros_changes.xls';
                link.click();
              }).finally(() => this.$store.dispatch("stop_loading"))
            }
        }
    };
</script>
               